import React, { useEffect } from 'react'
// import classNames from 'classnames';
import css from './ProfilePage.module.css';
import { ListingCardBox } from '../../components';

const ProfileListingsSwiper = ({listings, intl, reviews}) => {
  useEffect(() => {
    // Initialize Swiper
    setTimeout(function() {
      new Swiper('.yourListing-swiper-container', {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: true
        // },
        centeredSlides: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            autoplay: {
              delay: 1500,
              disableOnInteraction: true
            },
          },
          
          1024: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 30,
            initialSlide: 1,
            autoplay: {
              delay: 1500,
              disableOnInteraction: true
            },
          },
        }
      });
    }, 500);
  }, []);

  return (
    <div className="yourListing-swiper-container" data="yourListing-swiper-container">
      <div className="swiper-wrapper" data="img-swiper">
        
        { listings?.map((listing)=>(
            <div className="swiper-slide" data="img-swiper-slide"> 
              <ListingCardBox listing={listing} intl={intl} reviews={reviews} profilePage={true} />
            </div>
          ))
        }

        {/*<div className="swiper-slide" data="img-swiper-slide"> 
          <div className={css.trendingCard}>
            <div className={css.trendImgBox}>
              <img src="https://t4.ftcdn.net/jpg/03/17/25/45/360_F_317254576_lKDALRrvGoBr7gQSa1k4kJBx7O2D15dc.jpg" alt="card img" className={css.cardTrendImg} />
            </div>
            <div className={css.trendDetails}>
              <div className={css.location}>San Francisco</div>
              <div className={css.availProp}>+114<br/>Available Properties</div>
            </div>
          </div>
        </div>*/}

      </div>

      <div className="swiper-button-next" data="swiper-button-next">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
          <circle cx="12.4815" cy="11.5" r="11" transform="rotate(-180 12.4815 11.5)" fill="white" stroke="black"/>
          <path d="M11.2037 15.7593L15.463 11.5L11.2037 7.24076" stroke="black"/>
        </svg>
      </div>
      <div className="swiper-button-prev" data="swiper-button-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
          <circle cx="11.5" cy="11.5" r="11.5" fill="white"/>
          <circle cx="11.5" cy="11.5" r="11" stroke="black"/>
          <path d="M12.7778 7.24072L8.51852 11.5L12.7778 15.7592" stroke="black" />
        </svg>
      </div>
    </div>
  )
}
export default ProfileListingsSwiper;

